import { AgenticDesignSystemPage } from '../agentic/agentic-design-system-page'

export function DesignSystemListPage() {
  return <AgenticDesignSystemPage />
}
